module.exports = __webpack_public_path__ + "img/数字营销.0c1b13e4.png";